<template>
    <div v-if="client" class="container bng-casino-home bng-narrow-container">
        <!-- banner and last winnings -->
        <div class="bng-casino-home-banners">
            <div v-if="client.view.banners.casinoHomeBanner" class="bng-casino-home-swiper--big">
                <casino-home-custom-banner-2 />
            </div>
            <div v-if="client.view.banners.casinoHomeCustomBanner" class="bng-casino-home-swiper--small">
                <casino-home-custom-banner />
            </div>
        </div>
        <!-- highlights -->
        <h3
            v-if="popularGames && popularGames.length"
            class="title title-popular is-3 is-spaced has-text-centered"
        >
            {{"components.pages.casino-home.highlights" | translate}}
        </h3>

        <BkFrame
            :routePrefix="'/sport'"
            :component="'popular'"
            :outcomes="false" />

        <jackpot-fake/>
        <highlights-menu/>
        <!-- popular games -->
        <h3
            v-if="popularGames && popularGames.length"
            class="title title-popular is-3 is-spaced has-text-centered"
        >
            {{"components.pages.casino-home.popular" | translate}}
        </h3>
        <game-list v-if="popularGames && popularGames.length" :games="popularGames" />
    </div>
</template>
<script>
import Vue from 'vue';

import CasinoHomeCustomBanner from '../../../common/banners/casino-banners/casino-home-custom-banner.vue';
import CasinoHomeCustomBanner2 from '../../../common/banners/casino-banners/casino-home-custom-banner-2.vue';
import LastWinnings from '../../../common/last-winnings/last-winnings.vue';
import JackpotFake from '../../../common/jackpots/jackpot-fake/jackpot-fake.vue';
import GameList from '../../../common/game-list/game-list.vue';
import HighlightsMenu from '../../../common/highlights-menu/highlights-menu.vue';
import BkFrame from '../../../../../../_common/components/bk-frame.vue';

export default {
    name: 'casino-home',
    components: {CasinoHomeCustomBanner, CasinoHomeCustomBanner2, LastWinnings, JackpotFake, GameList, HighlightsMenu, BkFrame },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        popularGames() {
            return Vue.state.games.get().popular;
        },
        newGames() {
            return Vue.state.games.get().new;
        },
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (
                (this.player &&
                    this.player.balance &&
                    this.player.activeJackpots) ||
                []
            );
        }
    },
    async created() {
        await Vue.state.client.ensure();
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/casino-home/casino-main.vue